import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@material-ui/core";
import {
  FontButton,
  HeaderModal,
} from "../modalCadastroCliente/styles/ModalCadastroCliente";
import Chip from "../../../components/basics/Chip";
import {
  FornecedorContext,
  FornecedorContextProvider,
} from "../../../pages/prouser/fornecedores/contexts/FornecedorContext";
import { useCallback, useContext, useEffect } from "react";
import Loading from "../../../components/basics/Loading";
import useFornecedoresTelaController from "../../../pages/prouser/fornecedores/controllers/FornecedorController";
import { QueryParamsContext } from "../../../context/QueryParamsContext";
import { findClassificacoesfornecedores } from "../../../repository/ERP/prouser/ClassificacaoFornecedorService";
import { findBancos } from "../../../repositories/qerpapi/v3/BancosRepository";
import { findFornecedorServicos } from "../../../repository/admQERP/public/FornecedorServicos";
import Btn from "../../../components/buttons/Btn";
import { notify } from "../../../utils/notify";
import FormCadastroFornecedoresGeral from "./forms/CadastroFornecedorGeral";

const View = ({ open, setOpen, functionHandleSelectSupplier }) => {
  const { queryParams } = useContext(QueryParamsContext);
  const { clear, handleCreateModalFornecedor } =
    useFornecedoresTelaController();

  const {
    setListBank,
    setListClassifiction,
    setLoadingInputs,
    loading,
    setOptionsFilterProvider,
  } = useContext(FornecedorContext);

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    clear();
  }, [clear]);

  useEffect(() => {
    (async () => {
      try {
        setLoadingInputs((current) => ({
          ...current,
          listClassifiction: true,
        }));
        const resulClassifiction = await findClassificacoesfornecedores(
          queryParams.empresa_cnpj,
          1000
        );

        if (!resulClassifiction.success) {
          return notify(
            "Erro ao encontrar classificações de Fornecedores. Tente novamente!"
          );
        }

        setListClassifiction(resulClassifiction.data);
      } catch (error) {
        console.error(
          `Erro ao encontrar classificações de Fornecedores. Detalhes: ${error}`
        );
      } finally {
        setLoadingInputs((current) => ({
          ...current,
          listClassifiction: false,
        }));
      }
    })();
  }, [queryParams.empresa_cnpj, setListClassifiction, setLoadingInputs]);

  useEffect(() => {
    (async () => {
      try {
        setLoadingInputs((current) => ({
          ...current,
          listBank: true,
        }));

        const resultBank = await findBancos();

        if (!resultBank.success) {
          return notify("Erro ao encontrar bancos. Tente novamente!");
        }

        setListBank(resultBank.data);
      } catch (error) {
        console.error(`Erro ao encontrar bancos. Detalhes: ${error}`);
      } finally {
        setLoadingInputs((current) => ({
          ...current,
          listBank: false,
        }));
      }
    })();
  }, [queryParams.empresa_cnpj, setListBank, setLoadingInputs]);

  useEffect(() => {
    (async () => {
      try {
        setLoadingInputs((current) => ({
          ...current,
          optionsFilterProvider: true,
        }));

        const resultFornecedor = await findFornecedorServicos();

        if (!resultFornecedor.success) {
          return notify(
            "Erro ao encontrar serviços de fornecedores. Tente novamente!"
          );
        }

        if (resultFornecedor.data) {
          setOptionsFilterProvider(resultFornecedor.data);
        }
      } catch (error) {
        console.error(
          `Erro ao encontrar serviços de fornecedores. Detalhes: ${error}`
        );
      } finally {
        setLoadingInputs((current) => ({
          ...current,
          optionsFilterProvider: false,
        }));
      }
    })();
  }, [setLoadingInputs, setOptionsFilterProvider]);

  const getConditions = useCallback(
    () => ({
      showCondition: {
        contatos: queryParams.guia_fornecedores_contatos === "1",
        infosFinanceiras:
          queryParams.guia_fornecedores_infosfinanceiras === "1",
        integracoes: queryParams.guia_fornecedores_integracoes === "1",
        outrasInfos: queryParams.guia_fornecedores_outrasinfos === "1",
      },
    }),
    [
      queryParams.guia_fornecedores_contatos,
      queryParams.guia_fornecedores_infosfinanceiras,
      queryParams.guia_fornecedores_integracoes,
      queryParams.guia_fornecedores_outrasinfos,
    ]
  );

  return (
    <Dialog
      fullWidth={true}
      maxWidth="md"
      open={open}
      onClose={handleClose}
      aria-labelledby="dialog-cadastro-rapido-cliente"
    >
      <Loading open={loading} />
      <HeaderModal>
        <DialogTitle id="dialog-cadastro-rapido-cliente">
          <Chip
            label="CADASTRO RÁPIDO DE FORNECEDOR"
            bgcolor="primary"
            textcolor="white"
          />
        </DialogTitle>
      </HeaderModal>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item>
            <FormCadastroFornecedoresGeral />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <FontButton>
          <Grid container spacing={2}>
            <Grid item lg></Grid>
            <Grid item>
              <Btn
                label="Cadastrar"
                onClick={() => {
                  handleCreateModalFornecedor(
                    setOpen,
                    functionHandleSelectSupplier
                  );
                }}
              />
            </Grid>
            <Grid item>
              <Btn
                bgcolor="tertiary"
                hovercolor="blue"
                onClick={handleClose}
                label="Cancelar"
              />
            </Grid>
          </Grid>
        </FontButton>
      </DialogActions>
    </Dialog>
  );
};

const ModalCadastroFornecedor = ({ ...props }) => {
  return (
    <FornecedorContextProvider>
      <View {...props} />
    </FornecedorContextProvider>
  );
};

export default ModalCadastroFornecedor;
